import Modal from "src/components/common/modal";
import { boolOrReducer } from "src/components/common/functions";
import { myOptions, myAccessOptions } from "./userForm";
//-----------------------------------
export default function FilterForm({
    closeIt, setCurrentPage,
    curFilter, setFilter, userList,
    defaultFilter
}){
    return (
        <Modal
            touchOutsideClose = {true}
            closeIt = {closeIt}
            title = "Filter"
            width = {"60%"}
        >
            <div className = "m-3 row">
                <span className = "mr-3 font-weight-bold" style = {{alignSelf: "center"}}>Created By Me:</span>
                <input type = "checkbox" style = {{width: 30, height:30}} checked = {curFilter.mine} onChange = {e => setFilter({...curFilter, mine: e.currentTarget.checked})}/>
                {
                curFilter.mine?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, mine: false})}}>❌</span>:
                null
                }
            </div>
            <details open>
            <summary className = "ml-3 font-weight-bold h5 text-success">Basic Information</summary>

            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Current Employee:</span>
                <select className = "form-control inline" value = {curFilter.curEE} onChange = {e => setFilter({...curFilter, curEE: e.currentTarget.value})}>
                    <option>Yes</option>
                    <option>No</option>
                    <option>All</option>
                </select>
                {
                curFilter.curEE !== "Yes"?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, curEE: "Yes"})}}>❌</span>:
                null
                }
            </div>

            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Google Account:</span>
                <select className = "form-control inline" value = {curFilter.googleAccount} onChange = {e => setFilter({...curFilter, googleAccount: e.currentTarget.value})}>
                    <option>All</option>
                    <option value = "">Unkown</option>
                    <option>Yes</option>
                    <option>No</option>
                </select>
                {
                curFilter.googleAccount !== "All"?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, googleAccount: "All"})}}>❌</span>:
                null
                }
            </div>

            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Hire Date:</span>
                <span className = "mr-3">after:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = {curFilter.hireMax || "2999-12-31"}
                    className = "mr-3 form-control"
                    value = {curFilter.hireMin}
                    onChange = {e => {
                        setFilter({...curFilter, hireMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <span className = "mr-3">before:</span>
                <input
                    type = "date"
                    min = {curFilter.hireMin || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.hireMax}
                    onChange = {e => {
                        setFilter({...curFilter, hireMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.hireMax || curFilter.hireMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, hireMin: "", hireMax: ""})}}>❌</span>:
                null
                }
            </div>

            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Quit Date:</span>
                <span className = "mr-3">after:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = {curFilter.quitMax || "2999-12-31"}
                    className = "mr-3 form-control"
                    value = {curFilter.quitMin}
                    onChange = {e => {
                        setFilter({...curFilter, quitMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <span className = "mr-3">before:</span>
                <input
                    type = "date"
                    min = {curFilter.quitMin || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.quitMax}
                    onChange = {e => {
                        setFilter({...curFilter, quitMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.quitMax || curFilter.quitMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, quitMin: "", quitMax: ""})}}>❌</span>:
                null
                }
            </div>

            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Birthday:</span>
                <span className = "mr-3">after:</span>
                <input
                    type = "date"
                    min = "1900-01-01"
                    max = {curFilter.birthDayMax || "2999-12-31"}
                    className = "mr-3 form-control"
                    value = {curFilter.birthDayMin}
                    onChange = {e => {
                        setFilter({...curFilter, birthDayMin: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                <span className = "mr-3">before:</span>
                <input
                    type = "date"
                    min = {curFilter.hireMin || "1900-01-01"}
                    max = "2999-12-31"
                    className = "form-control"
                    value = {curFilter.birthDayMax}
                    onChange = {e => {
                        setFilter({...curFilter, birthDayMax: e.currentTarget.value});
                        setCurrentPage(1);
                    }}
                />
                {
                curFilter.birthDayMax || curFilter.birthDayMin?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, birthDayMin: "", birthDayMax: ""})}}>❌</span>:
                null
                }
            </div>

            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Region:</span>
                <select className = "form-control inline" value = {curFilter.region} onChange = {e => setFilter({...curFilter, region: e.currentTarget.value})}>
                    <option>All</option>
                    {myOptions.region.map((o, oi) => <option key = {oi}>{o}</option>)}
                </select>
                {
                curFilter.region !== "All"?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, region: "All"})}}>❌</span>:
                null
                }
            </div>

            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Department:</span>
                <select className = "form-control inline" value = {curFilter.department} onChange = {e => setFilter({...curFilter, department: e.currentTarget.value})}>
                    <option>All</option>
                    {Object.entries(myOptions.department).map(([key, value], k) => <optgroup label = {key} key = {k}>{value.map((v, vi) => <option key = {vi}>{v}</option>)}</optgroup>)}
                </select>
                {
                curFilter.department !== "All"?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, department: "All"})}}>❌</span>:
                null
                }
            </div>

            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Union Name:</span>
                <select className = "form-control inline" value = {curFilter.unionName} onChange = {e => setFilter({...curFilter, unionName: e.currentTarget.value})}>
                    <option>All</option>
                    {Object.keys(myOptions.phaseLevel).map((o, oi) => <option key = {oi}>{o}</option>)}
                </select>
                {
                curFilter.unionName !== "All"?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, unionName: "All", phaseLevel: "All"})}}>❌</span>:
                null
                }
            </div>

            <div className = "m-3">
                <span className = "mr-3 font-weight-bold">Phase Level:</span>
                <select className = "form-control inline" value = {curFilter.phaseLevel} onChange = {e => setFilter({...curFilter, phaseLevel: e.currentTarget.value})}>
                    <option>All</option>
                    {curFilter.unionName !== "All"?myOptions.phaseLevel[curFilter.unionName]?.map((option, i) => <option key = {i}>{option}</option>):null}
                </select>
                {
                curFilter.phaseLevel !== "All"?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, phaseLevel: "All"})}}>❌</span>:
                null
                }
            </div>
            </details>
            <details open = {Object.keys(myAccessOptions).map(key => curFilter[key] === "All"?false:true).reduce(boolOrReducer, false)}>
            <summary className = "ml-3 font-weight-bold h5 text-success">Access Control</summary>
            {Object.entries(myAccessOptions).map(([key, value], k) => <div key = {k} className = "m-3">
                <span className = "mr-3 font-weight-bold">{(key.charAt(0).toUpperCase() + key.slice(1)).match(/[A-Z][a-z]+/g)?.join(" ")}:</span>
                <select className = "form-control inline" value = {curFilter[key]} onChange = {e => setFilter({...curFilter, [key]: e.currentTarget.value})}>
                    <option>All</option>
                    {value.map((option, i) => <option key = {i}>{option}</option>)}
                </select>
                {
                curFilter[key] !== "All"?
                <span style = {{marginLeft: 10}} onClick = {() => {setFilter({...curFilter, [key]: "All"})}}>❌</span>:
                null
                }
            </div>)}
            </details>
            <div className = "mt-5 mb-3">
                <span className = "btn btn-secondary" onClick = {() => {
                    setFilter(defaultFilter);
                    setCurrentPage(1);
                }}>Clear Filter</span>
            </div>
        </Modal>
    )
}